import { CSSObject } from '@emotion/react'
import { fontSizes, fontWeights, fonts } from '@opallabs/pulsar'
import { colors } from '@opallabs/spectrum'

const getInputWrapper = (override: CSSObject): CSSObject => ({
  backgroundColor: colors.n10.base,
  borderRadius: '2px',
  padding: '16px 10px 16px 10px',
  'input[type="text"]::placeholder': {
    color: colors.n5.base,
  },
  '.kuiper-input-area': {
    height: '18px',
  },
  '.kuiper-input.kuiper-filled .kuiper-input-container': {
    backgroundColor: colors.n10.base,
  },
  '.kuiper-input-container': {
    alignItems: 'center',
    display: 'flex',
    paddingBottom: '7px',
  },
  '.kuiper-input.kuiper-focused, .kuiper-input': {
    '.kuiper-input-container': {
      backgroundColor: colors.n10.base,
    },
  },
  ...override,
})

// Styling for input placeholder and input text
const inputText: CSSObject = {
  border: 'none',
  fontFamily: fonts.sansSerif,
  fontWeight: fontWeights.bold,
  fontSize: fontSizes.xSmall,
  outline: 'none',
  color: colors.n5.base,
}

const styles = {
  getInputWrapper,
  inputText,
}

export { styles }
